/* @jsxImportSource react */

import type { VariantProps } from 'class-variance-authority';
import { priceVariants } from './Price.variants';

export type PriceProps = React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof priceVariants>;

export const Price = ({ children, size, alignment, className, ...rest }: PriceProps) => (
  <div {...rest} className={priceVariants({ size, alignment, className })}>
    {children}
  </div>
);

Price.displayName = 'Price';
